import React from 'react';
import ReactDOM from 'react-dom';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";

import Cart from './ecomm/Cart';
import InternetServices from './ecomm/products/InternetServices';
import TVServices from './ecomm/products/TVServices';
import PhoneServices from './ecomm/products/PhoneServices';
import ContactForm from './contact/ContactForm';
import ModemSwap from './ModemSwap';
import HardwareSetup from './HardwareSetup';
import ModemUpgrades from './ModemUpgrades';
import RateChecker from './ecomm/tools/RateChecker';
import TVChannelListing from './ecomm/tools/TVChannelListing';
import NineOneOne from './ecomm/tools/NineOneOne';
import Chatbot from './ecomm/tools/Chatbot';
import TVSupportedDevices from './ecomm/tools/TVSupportedDevices';
import NumberTransferForm from './number-transfer/NumberTransferForm';
import CheckAvailability from './ecomm/tools/CheckAvailability';
import BusinessServicesContactForm from './business/BusinessServicesContactForm';
import Moving from './moving/Moving';


jQuery( document ).ready( function(){
    if( headerVars.pageSlug == 'signup' ) {
        ReactDOM.createRoot(document.getElementById("react-ecommerce-container")).render(
            <React.StrictMode>
                <RouterProvider router={ router } />
            </React.StrictMode>
        );
    } 
    
    ReactDOM.render(<Cart />, document.querySelector("#react-cart-container")); 

    if( document.getElementById('react-openai-ui-container') ) {
        ReactDOM.render(<Chatbot />, document.querySelector("#react-openai-ui-container")); 
    }

    if( document.getElementById('react-check-availability-container') ) {
        ReactDOM.render(<CheckAvailability />, document.querySelector("#react-check-availability-container")); 
    }

    if( document.getElementById('react-service-details-container') ) {
        ReactDOM.render(<InternetServices isCartComponent={ false} />, document.querySelector("#react-service-details-container")); 
    }

    if( document.getElementById('react-service-details-container-home') ) {
        ReactDOM.render(
            <InternetServices 
                isCartComponent={ false } 
                isHomeComponent={ true }
            />,
            document.querySelector("#react-service-details-container-home")
        );  
    }

    if( document.getElementById('react-service-details-container-fibre') ) {
        ReactDOM.render(
            <InternetServices 
                isCartComponent={ false } 
                isFibreComponent={ true }
            />,
            document.querySelector("#react-service-details-container-fibre")
        ); 
    }

    if( document.getElementById('react-tv-service-details-container') ) {
        ReactDOM.render(<TVServices />, document.querySelector("#react-tv-service-details-container")); 
    }

    if( document.getElementById('react-phone-service-details-container') ) {
        ReactDOM.render(<PhoneServices />, document.querySelector("#react-phone-service-details-container")); 
    }

    if( document.getElementById('startca-react-contact-form') ) {
        ReactDOM.render(<ContactForm />, document.querySelector("#startca-react-contact-form")); 
    }

    if( document.getElementById('startca-react-modem-swap-form') ) {
        ReactDOM.render(<ModemSwap />, document.querySelector("#startca-react-modem-swap-form")); 
    }

    if( document.getElementById('startca-react-hardware-setup-component') ) {
        ReactDOM.render(<HardwareSetup />, document.querySelector("#startca-react-hardware-setup-component")); 
    }

    if( document.getElementById('startca-react-modem-upgrade-component') ) {
        ReactDOM.render(<ModemUpgrades />, document.querySelector("#startca-react-modem-upgrade-component")); 
    }

    if( document.getElementById('startca-react-rate-checker-component') ) {
        ReactDOM.render(<RateChecker />, document.querySelector("#startca-react-rate-checker-component")); 
    }

    if( document.getElementById('startca-react-channel-listing-component') ) {
        ReactDOM.render(<TVChannelListing />, document.querySelector("#startca-react-channel-listing-component")); 
    }

    if( document.getElementById('startca-react-nine-one-one-component') ) {
        ReactDOM.render(<NineOneOne />, document.querySelector("#startca-react-nine-one-one-component")); 
    }

    if( document.getElementById('startca-react-tv-supported-devices-component') ) {
        ReactDOM.render(<TVSupportedDevices />, document.querySelector("#startca-react-tv-supported-devices-component")); 
    }

    if( document.getElementById('startca-react-number-transfer-form') ) {
        ReactDOM.render(<NumberTransferForm />, document.querySelector("#startca-react-number-transfer-form")); 
    }

    if( document.getElementById('startca-react-moving-form') ) {
        ReactDOM.render(<Moving />, document.querySelector("#startca-react-moving-form")); 
    }

    if( document.getElementById('startca-react-business-contact-form-container') ) {
        ReactDOM.render(<BusinessServicesContactForm />, document.querySelector("#startca-react-business-contact-form-container")); 
    }
    
} );